define('v3/Common/Services/Backend/activeClassInDevicePoolBackend',['jquery', 'module', 'BackendBase'], function ($, module, BackendBase) {
	var ActiveClassInDevicePoolBackend = function () {
		BackendBase.call(this);
	};

	var actions = module.config().actions;

	ActiveClassInDevicePoolBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(ActiveClassInDevicePoolBackend.prototype, {

		getDevicesInfo: function () {
			return this._getJsonApi(actions.getDevicesInfo);
		},

		setActiveClass: function () {
			return this._postApi(actions.setActiveClass);
		}
	});

	return new ActiveClassInDevicePoolBackend();
});
